let dismissedForPageLoad = false;

export const isProfessionalHomeGreetingDismissedForPageLoad = () =>
	dismissedForPageLoad;

export const dismissProfessionalHomeGreetingForPageLoad = () => {
	dismissedForPageLoad = true;
};
